import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhotoSizeSelectActualIcon(props: IconProps) {
    return <Icon {...props} iconKey={"photo_size_select_actual"}/>
}
